import React, { useState } from "react";
import { Button } from "antd";
import useLang from "../../hooks/useLang";

/**
 * Confirmation for deleting a template.
 *
 * Its own dialog rather than the generic yes/no confirm because it names the
 * template being removed — with several similarly-worded templates in a list,
 * "Do you want to continue?" does not tell the user what they are about to
 * lose. Delete is the primary action and is styled destructively.
 *
 * The action row is left-aligned with the confirmed action first, which is where
 * every other template confirm puts it (`NewConfirmDialog`, behind the activate
 * and deactivate prompts) — a right-aligned row here made the same decision
 * arrive in a different place depending on which one the user happened to open.
 */
const TemplateDeleteDialog = ({ templateName, confirmCallback, onClose }) => {
  const [lang] = useLang();
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      await confirmCallback();
      onClose();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <p className="mt-2 mb-6 text-sm font-normal text-black/[0.88]">
        {(lang.deleteTemplateConfirm || "").replace("{name}", templateName || "")}
      </p>
      <div className="flex gap-2">
        <Button type="primary" danger loading={isLoading} onClick={handleDelete}>
          {lang.delete}
        </Button>
        <Button onClick={onClose}>{lang.cancel}</Button>
      </div>
    </div>
  );
};

export default TemplateDeleteDialog;
